import React, { useState, useEffect, useCallback } from 'react';
import PhoneInternational from '../../components/PhoneInternational';
import GenderEntry from '../../components/GenderEntry';
import PersonTypeToggle from '../../components/PersonTypeToggle';
import OcupationEntry from '../../components/Ocupation';
import HowYouMeet from '../../components/HowYouMeet';
import MinimalInput from '../../components/MinimalInput/MinimalInput';
import CustomButton from '../../components/CustomButton/CustomButton';
import { registerClient } from '../../services/api';
import { useNavigate } from 'react-router-dom';

export default function ClientSignUp({ isLawyer = false }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombre: '',
    apellidopaterno: '',
    apellidomaterno: '',
    correo: '',
    telefono: '',
    password: '',
    confirmPassword: '',
    personaMoral: '',
    isMoral: false,
    ocupation: '',
    fechaNacimiento: '',
    gender: '',
    formaConocernos: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  // const [genders, setGenders] = useState([]);
  // const [occupations, setOccupations] = useState([]);
  // const [howYouMeet, setHowYouMeet] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [phoneData, setPhoneData] = useState({
    dial_code: '52',
    iso2: 'mx',
    country: 'Mexico',
  });

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (isDataLoaded) return;

      try {
        // const [gendersData, occupationsData, howYouMeetData] = await Promise.all([
        //   getGenders(),
        //   getOccupations(),
        //   getHowYouMeet(),
        // ]);

        if (isMounted) {
          // setGenders(gendersData);
          // setOccupations(occupationsData);
          // setHowYouMeet(howYouMeetData);
          setIsDataLoaded(true);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        if (isMounted) {
          setError('Error al cargar los datos iniciales');
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [isDataLoaded]);

  const handleInputChange = useCallback(
    field => e => {
      setFormData(prev => ({
        ...prev,
        [field]: e.target.value,
      }));
    },
    []
  );

  const handleMoralChange = useCallback(value => {
    setFormData(prev => ({
      ...prev,
      isMoral: value,
    }));
  }, []);

  const handleOcupationChange = useCallback(value => {
    setFormData(prev => ({
      ...prev,
      ocupation: value,
    }));
  }, []);

  const handleGenderChange = useCallback(value => {
    setFormData(prev => ({
      ...prev,
      gender: value,
    }));
  }, []);

  const handleHowYouMeetChange = useCallback(value => {
    setFormData(prev => ({
      ...prev,
      formaConocernos: value,
    }));
  }, []);

  const handlePhoneChange = useCallback((phone, countryData) => {
    setFormData(prev => ({
      ...prev,
      telefono: phone,
    }));
    if (countryData) {
      setPhoneData({
        dial_code: countryData.dialCode || '52',
        iso2: countryData.iso2 || 'mx',
        country: countryData.name || 'Mexico',
      });
    }
  }, []);

  const validateFields = () => {
    const requiredFields = {
      nombre: 'Nombre',
      apellidopaterno: 'Apellido Paterno',
      apellidomaterno: 'Apellido Materno',
      correo: 'Correo Electrónico',
      telefono: 'Teléfono',
      password: 'Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      fechaNacimiento: 'Fecha de Nacimiento',
      gender: 'Género',
      ocupation: 'Ocupación',
      formaConocernos: 'Forma de conocernos',
    };

    const missingFields = [];
    for (const [field, label] of Object.entries(requiredFields)) {
      if (formData[field] === undefined || formData[field] === null || formData[field] === '') {
        missingFields.push(label);
      }
    }

    if (formData.isMoral && !formData.personaMoral) {
      missingFields.push('Nombre Persona Moral');
    }

    return missingFields;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Debug: Verifica el valor real
    console.log('formaConocernos:', formData.formaConocernos);

    // Validar campos requeridos
    const missingFields = validateFields();
    if (missingFields.length > 0) {
      setError(`Por favor complete los siguientes campos: ${missingFields.join(', ')}`);
      setLoading(false);
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      setLoading(false);
      return;
    }

    try {
      const clientData = {
        client_email: formData.correo,
        client_name: formData.nombre,
        client_apellido_P: formData.apellidopaterno,
        client_apellido_M: formData.apellidomaterno,
        client_name_moral: formData.isMoral ? formData.personaMoral : null,
        client_password: formData.password,
        id_client_tipo_persona: formData.isMoral ? 1 : 0,
        client_phone_number: formData.telefono,
        phone_dialcode: phoneData.dial_code,
        phone_iso2: phoneData.iso2,
        phone_country: phoneData.country,
        client_birthday: formData.fechaNacimiento,
        id_client_gender: formData.gender,
        id_client_ocupation: formData.ocupation,
        id_client_forma_conocernos: formData.formaConocernos,
        dTimeStamp: new Date().toISOString().slice(0, 19).replace('T', ' '),
      };

      console.log('Enviando datos al backend:', clientData);
      const response = await registerClient(clientData);
      console.log('Respuesta del backend:', response);

      if (response.status === 0) {
        console.log('Registro de cliente exitoso:', response);
        localStorage.setItem(
          'user',
          JSON.stringify({
            id: response.id,
            name: response.name,
            type: 'client',
          })
        );

        navigate('/client-dashboard');
      } else if (response.status === -1) {
        // Manejar errores específicos del backend
        if (response.message.includes('campo')) {
          setError(`Error: ${response.message}`);
        } else {
          setError(response.message || 'Error en el registro');
        }
      } else {
        setError('Error inesperado en el registro');
      }
    } catch (error) {
      console.error('Error en la petición:', error);
      setError(error.message || 'Error en el registro');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-4 px-4 md:px-0"
    >
      <MinimalInput
        label="Nombre"
        name="nombre"
        value={formData.nombre}
        onChange={handleInputChange('nombre')}
        placeholder="Tu nombre"
        className={`rounded-md px-4 py-3 text-base transition-colors duration-200 ${
          isLawyer
            ? 'bg-transparent border border-gray-400 text-white placeholder-gray-300 focus:ring-gray-200'
            : 'bg-white border border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-blue-200'
        }`}
      />
      <MinimalInput
        label="Apellido Paterno"
        name="apellidopaterno"
        value={formData.apellidopaterno}
        onChange={handleInputChange('apellidopaterno')}
        placeholder="Apellido paterno"
        className={`rounded-md px-4 py-3 text-base transition-colors duration-200 ${
          isLawyer
            ? 'bg-transparent border border-gray-400 text-white placeholder-gray-300 focus:ring-gray-200'
            : 'bg-white border border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-blue-200'
        }`}
      />
      <MinimalInput
        label="Apellido Materno"
        name="apellidomaterno"
        value={formData.apellidomaterno}
        onChange={handleInputChange('apellidomaterno')}
        placeholder="Apellido materno"
        className={`rounded-md px-4 py-3 text-base transition-colors duration-200 ${
          isLawyer
            ? 'bg-transparent border border-gray-400 text-white placeholder-gray-300 focus:ring-gray-200'
            : 'bg-white border border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-blue-200'
        }`}
      />
      <MinimalInput
        label="Correo Electrónico"
        name="correo"
        type="email"
        value={formData.correo}
        onChange={handleInputChange('correo')}
        placeholder="ejemplo@correo.com"
        className={`rounded-md px-4 py-3 text-base transition-colors duration-200 ${
          isLawyer
            ? 'bg-transparent border border-gray-400 text-white placeholder-gray-300 focus:ring-gray-200'
            : 'bg-white border border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-blue-200'
        }`}
      />
      <div className="flex flex-col w-full mb-6">
        <label
          className={`text-xs mb-1 ${isLawyer ? 'text-gray-300' : 'text-gray-500'}`}
          htmlFor="telefono"
        >
          Teléfono
        </label>
        <PhoneInternational id="telefono" theInput={val => val} thePhone={handlePhoneChange} />
      </div>
      <MinimalInput
        label="Contraseña"
        name="password"
        type="password"
        value={formData.password}
        onChange={handleInputChange('password')}
        placeholder="••••••••"
        className={`rounded-md px-4 py-3 text-base transition-colors duration-200 ${
          isLawyer
            ? 'bg-transparent border border-gray-400 text-white placeholder-gray-300 focus:ring-gray-200'
            : 'bg-white border border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-blue-200'
        }`}
      />
      <MinimalInput
        label="Confirmar Contraseña"
        name="confirmPassword"
        type="password"
        value={formData.confirmPassword}
        onChange={handleInputChange('confirmPassword')}
        placeholder="••••••••"
        className={`rounded-md px-4 py-3 text-base transition-colors duration-200 ${
          isLawyer
            ? 'bg-transparent border border-gray-400 text-white placeholder-gray-300 focus:ring-gray-200'
            : 'bg-white border border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-blue-200'
        }`}
      />
      <div className="flex flex-col w-full mb-6">
        <label className={`text-xs mb-1 ${isLawyer ? 'text-gray-300' : 'text-gray-500'}`}>
          Género
        </label>
        <GenderEntry onGenderChange={handleGenderChange} />
      </div>
      <div className="flex flex-col w-full mb-6 items-start">
        <label className={`text-xs mb-3 ${isLawyer ? 'text-gray-300' : 'text-gray-500'}`}>
          Tipo de Persona
        </label>
        <PersonTypeToggle
          isMoral={formData.isMoral}
          onPersonTypeChange={handleMoralChange}
          isLawyer={isLawyer}
        />
      </div>
      <MinimalInput
        label="Nombre Persona Moral"
        name="personaMoral"
        value={formData.personaMoral}
        onChange={handleInputChange('personaMoral')}
        placeholder="Nombre de la persona moral"
        disabled={!formData.isMoral}
        className={`rounded-md px-4 py-3 text-base transition-colors duration-200 ${
          isLawyer
            ? 'bg-transparent border border-gray-400 text-white placeholder-gray-300 focus:ring-gray-200'
            : 'bg-white border border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-blue-200'
        }`}
      />
      <MinimalInput
        label="Fecha de Nacimiento"
        name="fechaNacimiento"
        type="date"
        value={formData.fechaNacimiento}
        onChange={handleInputChange('fechaNacimiento')}
        className={`rounded-md px-4 py-3 text-base transition-colors duration-200 ${
          isLawyer
            ? 'bg-transparent border border-gray-400 text-white placeholder-gray-300 focus:ring-gray-200'
            : 'bg-white border border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-blue-200'
        }`}
      />
      <div className="flex flex-col w-full mb-6">
        <label className={`text-xs mb-1 ${isLawyer ? 'text-gray-300' : 'text-gray-500'}`}>
          Ocupación
        </label>
        <OcupationEntry onOcupationChange={handleOcupationChange} />
      </div>
      <div className="flex flex-col w-full mb-6">
        <label className={`text-xs mb-1 ${isLawyer ? 'text-gray-300' : 'text-gray-500'}`}>
          ¿Cómo nos conoció?
        </label>
        <HowYouMeet onHowYouMeetChange={handleHowYouMeetChange} />
      </div>
      {error && (
        <div className="col-span-1 md:col-span-2 text-red-500 text-xs mb-2 text-center">
          {error}
        </div>
      )}
      <div className="col-span-1 md:col-span-2 flex justify-center mt-6">
        <CustomButton
          type="submit"
          text={loading ? 'Registrando...' : 'Crear Cuenta'}
          disabled={loading}
          className="w-full justify-center py-3 text-base"
        />
      </div>
    </form>
  );
}
